import StatusChip from "@entrilia/shared/components/StatusChip";
import type { PortalPageStatus } from "./portalPageStatusHelper";

interface Props {
  value: PortalPageStatus;
}

const PortalPageStatusChip = ({ value }: Props) => {
  switch (value) {
    case "off":
      return <StatusChip label="Off" withDot color={(t) => t.palette.text.secondary} />;
    case "preview":
      return <StatusChip label="Preview" withDot color={(t) => t.palette.info.dark} />;
    case "live":
      return <StatusChip label="Live" withDot color={(t) => t.palette.success.main} />;
    default:
      return null;
  }
};

export default PortalPageStatusChip;
